


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { cardStatusMap } from '@/utils/status-map'

@Component
export default class StatusEffective extends Vue {
    statusMap = cardStatusMap
    @Prop() status!: number
}
